import {dynamicApiCall} from "./dynamicApiCall";

export const dashboard = async () => {
  const option = {
    method: 'GET',
    endpoint: '/states/'
  }

  const response = await dynamicApiCall(option)

  if (response.status === 200) {
    return response
  } else {
    throw response
  }
};